export default {
  name: 'ScriptPack',
};
